import fireb from "../firebase/fireBase"
import firebase from 'firebase/app'

const db = fireb.firestore()
const date = firebase.firestore.FieldValue.serverTimestamp()

const createDocument = async (content, collection, id, forceCreate = false) => {

    if (id) {
        let Ref = db.collection(collection).doc(id)

        if (forceCreate) {
            return Ref.set({
                ...content,
                created: date
            }).then(refDoc => ({ content, id }))
        }

        return Ref.update({
            ...content,
            updated: date
        }).then(refDoc => ({ content, id }))
    } else {
        return db.collection(collection).add({
            ...content,
            created: date
        })
            .then(refDoc => {
                let Ref = db.collection(collection).doc(refDoc.id)
                Ref.update({ 'id': refDoc.id })
                return ({ content, id: refDoc.id })
            })
            .catch(error => {
                console.error(error)
            })
    }

}

const saveDocument = (content, collection, id, callback) => {

    if (id) {
        let Ref = db.collection(collection).doc(id)
        return Ref.update({
            ...content,
            updated: date
        })
            .then(refDoc => {
                callback(content, id)
            })
    } else {
        db.collection(collection).add({
            ...content,
            created: date
        })
            .then(refDoc => {
                let Ref = db.collection(collection).doc(refDoc.id)
                Ref.update({ 'id': refDoc.id })
                callback(content, refDoc.id)
            })
            .catch(error => {
                console.error(error)
            })
    }

}

const getDocumentList = (collection, where, callback, realTime = false) => {

    let collectionRef = db.collection(collection), query

    query = collectionRef

    if (where) {
        where.forEach(w => {
            query = query.where(w.field, w.operator, w.value)
        })
    }

    if (!realTime) {

        query.get()
            .then((querySnapshot) => {
                let dataArr = [], contentlist = []
                querySnapshot.forEach(d => {
                    let dataObj = d.data()
                    dataObj.key = d.id
                    dataObj.id = d.id

                    dataArr.push(dataObj)
                    contentlist.push({
                        ...dataObj
                    })
                })
                callback(dataArr)
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            })

    } else {
        let unsubscribe = query.onSnapshot(res => {
            if (res.empty) {
                callback([])
            } else {
                let dataArr = [], contentlist = []
                res.forEach(d => {
                    let dataObj = d.data()
                    dataObj.key = d.id
                    dataObj.id = d.id

                    dataArr.push(dataObj)
                    contentlist.push({
                        ...dataObj
                    })
                })
                callback(dataArr)
            }
        })

        return unsubscribe

    }

}

const getDocument = async (collection, where, callback, realTime = false) => {

    if (realTime) {
        let unsubscribe = await db.collection(collection)
            .where(where.field, where.operator, where.value)
            .onSnapshot(res => {
                if (res.empty) {
                    // console.log('')
                } else {
                    var dataArr = [], contentlist = []

                    res.forEach(d => {
                        let dataObj = d.data()
                        dataObj.key = d.data()[where.field]

                        dataArr.push(dataObj)
                        contentlist.push({
                            ...dataObj
                        })
                    })
                    callback(dataArr[0])
                }
            })

        return unsubscribe

    } else {
        let dataArr = [], contentlist = []
        await db.collection(collection)
            .where(where.field, where.operator, where.value)
            .get()
            .then(function (querySnapshot) {

                querySnapshot.forEach(d => {
                    let dataObj = d.data()
                    dataObj.key = d.data()[where.field]

                    dataArr.push(dataObj)
                    contentlist.push({
                        ...dataObj
                    })
                })
            })
            .catch(function (error) {
                console.log("Error getting documents: ", error);
            })

        return dataArr[0]
    }

}

const setPublished = (type, collection, id, published) => {
    let Ref = db.collection(`apps/${collection}/${type}`).doc(id)
    return Ref.update({ 'published': published })
}

const staticQuery = async (collection, where, orderBy = null, limit = 0) => {

    let query = db.collection(collection)

    if (typeof (where) === 'object') {
        where.forEach(w => {
            query = query.where(w.field, w.operator, w.value)
        })
    } else if (typeof (where) === 'string') {
        query = query.doc(where)
    }

    if(orderBy){
        query = query.orderBy(orderBy.field, orderBy.sort)
    }

    if (limit !== 0) {
        query = query.limit(limit)
    }

    return await query
        .get()
        .then((querySnapshot) => {

            let dataArr = [], contentlist = []

            querySnapshot.forEach(d => {
                let dataObj = d.data()
                dataObj.key = d.id
                dataObj.id = d.id

                dataArr.push(dataObj)
                contentlist.push({
                    ...dataObj
                })
            })

            return dataArr
        })

}

const deleteDocument = async (appid, type, id) => {
    let query

    if (type === 'deletePN') {
        query = db.collection('scheduledNotifications')
    } else {
        query = db.collection(`apps/${appid}/${type}`)
    }

    return await query
        .doc(id)
        .delete()
        .catch(error => console.error('Error deleting: ', error))
}

const batchOperations = (appid, collection, data = [{ id: '', data: '', action: '' }]) => {
    let batch = db.batch()

    data.forEach(d => {
        let ref = db.collection(`apps/${appid}/${collection}`).doc(d.id)

        switch (d.action) {
            case 'update':
                batch.update(ref, { ...d.data })
                break
            case 'set':
                batch.set(ref, { ...d.data })
                break
            case 'delete':
                batch.delete(ref)
                break
            default:
                break
        }
    })

    return batch.commit()
}

const batchCreate = async (appid, collection, data = []) => {
    let batch = db.batch()

    data.forEach(d => {
        let ref = db.collection(`apps/${appid}/${collection}`).doc()
        batch.set(ref, { ...d })
    })

    return await batch.commit()
}

export {
    createDocument,
    saveDocument,
    getDocument,
    getDocumentList,
    setPublished,
    staticQuery,
    deleteDocument,
    batchOperations,
    batchCreate
}